
















import Vue from "vue";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";
import { Trans } from "@/shared/scripts/helpers/translation/translation";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect,
    },
    data: function() {
        return {
            pathInStore: "customer.language",
        };
    },
    computed: {
        customerLanguage: function(): string {
            return this.$store.getters["FormModule/getValueUI"](this.pathInStore);
        },
        options: function(): Array<Record<string, unknown>> {
            return [
                {
                    "label": this.$t("french_language"),
                    "value": "FR"
                },
                {
                    "label": this.$t("dutch_language"),
                    "value": "NL"
                },
                {
                    "label": this.$t("english_language"),
                    "value": "EN"
                }
            ];
        }
    },
    created: function() {
        if (!this.$store.getters["FormModule/getValueUI"](this.pathInStore)) {
            this.$store.commit("FormModule/addValueUI", {
                "path": this.pathInStore,
                "value": Trans.currentLocale.toUpperCase(),
            });
        }
    },
    methods: {
        updateCustomerLanguage: function(value: string): void {
            if (value != "") {
                this.$store.commit("FormModule/addValueUI", {"path": this.pathInStore, "value": value});
            }
        }
    },

});

